export default __webpack_public_path__ + "static/media/iso45001.a2fca1bf.jpeg";